import { ICollectorData } from 'legacy/lut/components/widgets/public/onboarding/requestsInfo/requestDetail/actionView/dataCollector/ICollectorData'

import { IQueryResult, Logic, Operator } from 'core-components/types'
import {
  collectedDataApi,
  CollectedDataCacheKey,
  ISaveCollectedDataParams,
  TCollectedDataFetchOptions,
} from 'onboarding/api/collectedDataApi'

class CollectedDataService {
  public getCrud(cacheKey?: CollectedDataCacheKey) {
    return collectedDataApi.getCrud(cacheKey)
  }

  public delete(item: ICollectorData) {
    return collectedDataApi.delete(item)
  }

  public create(items: ICollectorData[]) {
    return collectedDataApi.create(items)
  }

  public update(items: ICollectorData[]) {
    return collectedDataApi.update(items)
  }

  public getByRequestId(requestId: number, options: TCollectedDataFetchOptions) {
    return collectedDataApi.getManyByRequestId(requestId, options)
  }

  public getRequestFilesRows(
    requestId: number,
    field: string,
    options: TCollectedDataFetchOptions
  ) {
    return collectedDataApi.getRequestFilesRows(requestId, field, options)
  }

  public getSyncedWithParent(requestId: number, actionUUID: string) {
    return collectedDataApi.getSyncedWithParent(requestId, actionUUID)
  }

  public async saveAndSyncWithParent(payload: ISaveCollectedDataParams, accessToken: string) {
    return collectedDataApi.saveAndSyncWithParent(payload, accessToken)
  }

  public fetchLastRequestReject(requestId: number) {
    return collectedDataApi.fetchLastRequestReject(requestId)
  }

  public fetchManyRequestFields(
    requestId: number,
    fields: string[],
    cacheKey?: CollectedDataCacheKey
  ): Promise<IQueryResult<any, any>> {
    const source = this.getCrud(cacheKey)
    source.setFilter({
      logic: Logic.AND,
      filters: [
        {
          field: 'RequestId',
          operator: Operator.EQUAL,
          value: requestId,
        },
        {
          logic: Logic.OR,
          filters: fields.map((i) => ({
            field: 'Field',
            operator: Operator.EQUAL,
            value: i,
          })),
        },
      ],
    })

    return source.fetch()
  }

  public fetchManyExceptionFields(
    requestId: number,
    cacheKey?: CollectedDataCacheKey
  ): Promise<IQueryResult<any, any>> {
    return this.fetchManyRequestFields(
      requestId,
      [
        'BusinessJustification',
        'ExceptionSubReason',
        'ExceptionReason',
        'ExceptionCategoryGUID',
        'ExceptionProofs',
        'FlaggingEffect',
        'IsExceptionRequestPartnerThresholdConfirmed',
      ],
      cacheKey
    )
  }
}

export const collectedDataService = new CollectedDataService()
